import { filter, find, pathEq, sortBy, values } from 'ramda';
import type { RootState } from 'reactApp/store';
import type { LoadingState } from 'reactApp/types/commonStates';
import { createSelector } from 'reselect';

import type { IReceivedGift } from './giftReceived.types';

// tempexp_16481-next-line
const AUTOUPLOAD_10TB_GIFT_ID = 'G10T_single_quota_2023';

// tempexp_16481-next-line
const notDiscount = (gift: IReceivedGift) => !gift.discount && gift.id !== AUTOUPLOAD_10TB_GIFT_ID;
const isDiscount = (gift: IReceivedGift) => !!gift.discount;

const getGiftsState = (state: RootState) => state.receivedGifts;

const getGifts = (state) => state.receivedGifts.list as Record<string, IReceivedGift>;
export const getRawGiftsList = (state) => state.receivedGifts.rawList as { gift_id: string }[];

const filterNonDiscountGifts = createSelector(getGifts, (list) => list && filter(notDiscount, list));

const filterDiscountGifts = createSelector(getGifts, (list) => list && filter(isDiscount, list));

export const sortReceivedGiftsByStart = createSelector(filterNonDiscountGifts, (list) => sortBy(({ start }) => start, values(list)));

export const getDiscountGiftList = createSelector(filterDiscountGifts, values);

export const getDiscountGiftByProductId = createSelector(
    getDiscountGiftList,
    (state, productId) => productId,
    (discountGifts, productId) => find(pathEq(['discount', 'web'], productId), values(discountGifts))
);

export const getReceivedGiftsLoadingState = createSelector(
    getGiftsState,
    (state): LoadingState => ({
        isLoading: state.isLoading,
        isLoaded: state.isLoaded,
    })
);

// tempexp_16481-start
export const hasAutoupload10TbGift = createSelector(getRawGiftsList, (list) => {
    return Boolean(Object.values(list).find((item) => item.gift_id === AUTOUPLOAD_10TB_GIFT_ID));
});
// tempexp_16481-end
